<template>
  <b-modal
    header-close-content=""
    id="confirm-modal"
    ref="confirmationModal"
    v-model="viewModel.showConfirmation"
    :title="viewModel.title"
    no-close-on-backdrop
    no-close-on-esc>
    <div>
      <b-form-group v-if="viewModel.showCheckOption">
        <p style="white-space: pre-line" v-dompurify-html="viewModel.question"></p>
        <b-checkbox class="text-nowrap" v-model="viewModel.checkOption">{{ $t("messageNotShowAgain") }}</b-checkbox>
      </b-form-group>
      <p style="white-space: pre-line" v-dompurify-html="viewModel.question" v-else class="mb-0"></p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" variant="primary">{{ $t(`${viewModel.okButtonText}`) }}</b-btn>
      <b-btn @click="cancel">{{ $t(`${viewModel.cancelButtonText}`) }}</b-btn>
    </template>
  </b-modal>
</template>

<script lang="ts" setup>
import { ref, reactive } from "vue";

const viewModel = reactive({
  showConfirmation: false,
  checkOption: false,
  title: "",
  question: "",
  showCheckOption: true,
  okButtonText: "OK",
  cancelButtonText: "Cancel"
});

const confirmationModal = ref();

function getConfirmation(
  title: string,
  question: string,
  showCheckOption: boolean = true,
  okButtonText: string = "OK",
  cancelButtonText: string = "Cancel"
): Promise<boolean> {
  viewModel.showConfirmation = true;
  viewModel.title = title;
  viewModel.question = question;
  viewModel.checkOption = false;
  viewModel.showCheckOption = showCheckOption;
  viewModel.okButtonText = okButtonText;
  viewModel.cancelButtonText = cancelButtonText;

  return new Promise<boolean>((accept, reject) => {
    const acceptHandler = () => {
      // We need to show other modal dialogs in after closing this dialog
      // but nextTick is not delaying until the dialog is properly hidden.
      // So using the setTimeout as a workaround.
      setTimeout(() => {
        accept(viewModel.checkOption);
      }, 10);
      confirmationModal.value?.hide();
      confirmationModal.value?.$off("ok", acceptHandler);
    };

    const rejectHandler = () => {
      reject();
      confirmationModal.value?.hide();
      confirmationModal.value?.$off("cancel", rejectHandler);
      confirmationModal.value?.$off("close", rejectHandler);
    };

    confirmationModal.value?.$on("ok", acceptHandler);
    confirmationModal.value?.$on("cancel", rejectHandler);
    confirmationModal.value?.$on("close", rejectHandler);
  });
}

defineExpose({
  getConfirmation: getConfirmation
});
</script>
<style></style>
